export default __webpack_public_path__ + "static/media/LogoCaja.6d753997.png";